import Cookies from "js-cookie";

const TOKEN_KEY = "token";

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);

  return token || "";
};

export const setToken = (token: string) => {
  return Cookies.set(TOKEN_KEY, token);
};
